module.exports = require('./helpers/bundle-url').getBundleURL('455Cc') + "logo.c51670a8.svg";